import { BruksklasseModulvogntog, BruksklasserModulvogntog, useRouteSettings, useRouteSettingsActions } from "../../stores/RouteSettingsStore";
import { CheckboxInput } from "../common/CheckboxInput";
import { SelectInput } from "../common/SelectInput";

export default function BruksklasseModulvogntogSettings() {
    const routeSettings = useRouteSettings();
    const { setRouteSettings } = useRouteSettingsActions();

    return (
        <>
        {routeSettings.routeType === "bruksklasseModulvognTog" && 
            <>
                <SelectInput<BruksklasseModulvogntog>
                    allowedValues={BruksklasserModulvogntog}
                    label="bruksklasse modulvogntog"
                    value={routeSettings.bruksklasseModulvogntog!}
                    onChange={(value:BruksklasseModulvogntog) => {setRouteSettings({...routeSettings, bruksklasseModulvogntog: value})}}
                />
                <CheckboxInput
                    label="Med sporingskrav"
                    value={routeSettings.medSporingskrav}
                    onChange={(value:boolean) => {setRouteSettings({...routeSettings, medSporingskrav: value})}}
                />
                <CheckboxInput
                    label="Er link semitrailer"
                    value={routeSettings.erLinkSemiTrailer}
                    onChange={(value:boolean) => {setRouteSettings({...routeSettings, erLinkSemiTrailer: value})}}
                />
            </>
        }
        </>
    )
    
}